// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__lEw5V","inputWrap":"styles_inputWrap__3TtUb","input":"styles_input__3mFWe"};